import { createContext, useContext } from 'react';

export const WindowRefContext = createContext<Window | undefined>(window);

export const useWindowRef = () => {
    const windowRef = useContext(WindowRefContext);

    if (!windowRef) {
        return window;
    }

    return windowRef;
};
